module.exports = __webpack_public_path__ + "static/img/arnergy-10000x.f8f212b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arnergy-10000x.png
// module id = 2814
// module chunks = 1